// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"a86d120a","283":"ec17dd6a","440":"794e00c4","453":"0b8724da","470":"db252a98","603":"a2c1279b","687":"02a9cf03","771":"5c507d07"}[chunkId] + ".chunk.js";
};